export default __webpack_public_path__ + "static/media/logo-border.14903005.svg";